import React from 'react';
import styled, {ThemeProvider} from 'styled-components';
import {getTheme} from '@ey/styled-theme';
import {Theme} from '../../utils/uiconstants';

export const CustomTooltip = ({
	color,
	percentage,
	point,
	total,
	x,
	y,
	tooltipMessage,
	children,
	theme
}) => {
	return (
		<ThemeProvider theme={getTheme(theme === Theme.Dark)}>
			<StyledCustomTooltip>
				{children &&
					React.cloneElement(children, {
						color,
						percentage,
						point,
						total,
						tooltipMessage,
						x,
						y
					})}
			</StyledCustomTooltip>
		</ThemeProvider>
	);
};

export default CustomTooltip;

const StyledCustomTooltip = styled.section`
	display: flex;
	height: 100%;
	width: 100%;
	color: ${(props) => props.theme.color[`black`]};
`;
